<template>
  <th
    class="tw-h-10 first:tw-px-2.5 last:tw-px-2.5 tw-pr-2.5 xl:tw-px-2.5 tw-space-x-1.5 tw-whitespace-nowrap game-tile-background-color game-secondary-button-border-color tw-border-y first:tw-border-l last:tw-border-r"
    :class="[
      {
        'tw-sticky tw-shadow-cell-left tw-shadow-[var(--tile-border-color)] tw-right-0':
          hasRightScroll,
      },
      sortOptions && sort && sortable
        ? 'tw-cursor-pointer tw-group'
        : 'tw-cursor-default',
    ]"
    @click="updateSort"
  >
    <div class="tw-inline-flex tw-space-x-1.5">
      <span
        class="tw-opacity-60 mod-button-transition"
        :class="{
          'group-hover:game-link-color group-hover:tw-opacity-100': sortable,
        }"
      >
        {{
          skipTranslation
            ? label
            : label && $t(label, { ugc: ugcName(null, true, false).value })
        }}
      </span>
      <div
        v-if="sortable"
        class="tw-flex tw-flex-col tw-h-4 tw-relative tw-top-px"
      >
        <font-awesome-icon
          icon="angle-up"
          size="xl"
          class="tw-left-0 tw-transition-all tw--mt-px"
          :class="[
            {
              'tw-rotate-180':
                (!showCaretUp && isSorted) || (!isSorted && defaultCaretDown),
            },
            isSorted ? 'game-link-color' : 'tw-opacity-30 tw-text-theme',
          ]"
        />
      </div>
    </div>
  </th>
</template>

<script>
import { useResourceValue } from '@composables'
import { computed, toRefs, inject } from 'vue'
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    sort: {
      type: Object,
      default: null,
    },
    sortOptions: {
      type: Object,
      default: null,
    },
    sortable: {
      type: Boolean,
      default: true,
    },
    hasRightScroll: {
      type: Boolean,
      default: false,
    },
    skipTranslation: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:sort'],
  setup(props, { emit }) {
    const { sort, sortOptions, sortable } = toRefs(props)
    const activeIndex = inject('activeIndex', false)
    const { ugcName } = useResourceValue()

    function updateSort() {
      if (
        sortOptions.value &&
        sortable.value &&
        !activeIndex.value &&
        activeIndex.value !== 0
      ) {
        emit('update:sort', sortOptions.value)
      }
    }

    const isSorted = computed(
      () => sort.value?.sortBy === sortOptions.value?.key
    )

    const showCaretDown = computed(
      () =>
        (sort.value?.order === 'desc' && !sort.value?.reverse) ||
        (sort.value?.order === 'asc' && sort.value?.reverse)
    )

    const showCaretUp = computed(
      () =>
        (sort.value?.order === 'asc' && !sort.value?.reverse) ||
        (sort.value?.order === 'desc' && sort.value?.reverse)
    )

    const defaultCaretDown = computed(
      () => sortOptions.value?.direction === 'desc'
    )

    return {
      defaultCaretDown,
      showCaretDown,
      showCaretUp,
      updateSort,
      isSorted,
      ugcName,
    }
  },
}
</script>
